import type {
    JournalCategory,
    LabCategory,
    LabStatus,
    ProjectCategory
} from '@/types'

/**
 * Category and status vocabularies. The registries in src/content are
 * validated against these lists at build time, so a typo fails loudly.
 * Order here is the order filters appear in.
 */

export const PROJECT_CATEGORIES: Record<ProjectCategory, string> = {
    'healthcare': 'Healthcare Software',
    'ai-applications': 'AI Applications',
    'infrastructure': 'Self-hosted Infrastructure',
    'developer-tools': 'Developer Tools',
    'automation': 'Workflow Automation'
}

export const LAB_CATEGORIES: Record<LabCategory, string> = {
    'ai-agents': 'AI Agents',
    'agent-infrastructure': 'Agent Infrastructure',
    'workflow-automation': 'Workflow Automation',
    'self-hosted-ai': 'Self-hosted AI',
    'open-source-tools': 'Open Source Tools',
    'experimental': 'Experimental Projects'
}

export const LAB_STATUSES: Record<LabStatus, { label: string, description: string }> = {
    exploring: {
        label: 'Exploring',
        description: 'Early research. Questions outnumber answers.'
    },
    active: {
        label: 'Active',
        description: 'Running and maintained. Notes are updated as it changes.'
    },
    archived: {
        label: 'Archived',
        description: 'Concluded. Kept for the record, with what was learned.'
    }
}

export const JOURNAL_CATEGORIES: Record<JournalCategory, string> = {
    'software-engineering': 'Software Engineering',
    'ai-automation': 'AI & Automation',
    'linux-infrastructure': 'Linux & Infrastructure',
    'developer-tools': 'Developer Tools',
    'tutorials': 'Tutorials',
    'field-notes': 'Field Notes'
}
